// 地面站设置
export default {
    language: 'язык',
    company: 'Единицы измерения',
    metricSystem: 'Метрическая система(m/s)',
    britishSystem: 'английская система мер(mph)',
    trajectory: 'Следы полета',
    trajectoryShow: 'показать',
    trajectoryHide: 'скрыть',
    mapCenter: 'Центр карты',
    lng: 'долгота',
    lat: 'широты',
    baseStationSettings: 'Настройки базовой станции',
    cloudBasedStation: 'Облачная базовая станция',
    mobileBasedStation: 'Мобильная базовая станция',
    messageSettings: 'Настройки сообщений',
    AP: 'странное напоминание',
    SP: 'Системный продвгание',
    basicSettings: 'Базовые настройки',
    DID: 'Отображение информации по умолчанию',
    BSD: 'Отображение базовой станции',
    NFZD: 'Отображение бесполетной зоны',
    WDV: 'Значения по умолчанию для путевых точек',
    WH: 'Bысота',
    WS: 'Cкорость',
    WR: 'Pадиус',
    HT: 'Время зависании',
    HM: 'Модель путевой точки',
    circlingDirection: 'Направление вращения',
    clockwise: 'По часовой стрелке',
    counterclockwise: 'Против часовой стрелки',
    PTDV: 'Указание значения по умолчанию',
    waitingTime: 'время ожидания',
    circlingRadius: 'Радиус поворота',
    cycles: 'Циклы',
    tip_PELng: 'Пожалуйста, введите долготу',
    tip_PELat: 'Пожалуйста, введите широту',
    tip_PEAI: 'Пожалуйста, введите целое число',
    tip_IAL: '0 всегда цикл',
    tip_ETNO: 'Неправильно введите количество циклов',
}